import { eachDayOfInterval, format, getDay } from 'date-fns'

export const DateUtilsRoomsSessions = () => {
  function getDatesByWeekDays(startDate: Date, endDate: Date, weekDays: number[]): Date[] {
    const allDates = eachDayOfInterval({ start: startDate, end: endDate })
    const filteredDates = allDates.filter((date) => weekDays.includes(getDay(date)))
    return filteredDates
  }

  const returnOnlyDates = (dates: Date[]) => {
    return dates.map((date) => {
      return date.toISOString().split('T')[0]
    })
  }

  const returnWithInitAndFinishDate = (date: string, initDate: string, finishDate: string): { init: string; finish: string } => {
    return {
      finish: `${date}T${initDate}:00`,
      init: `${date}T${finishDate}:00`
    }
  }

  const removeTimezone = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm")

  return {
    returnOnlyDates,
    getDatesByWeekDays,
    returnWithInitAndFinishDate,
    removeTimezone
  }
}
